export default __webpack_public_path__ + "static/media/left-arrow.e95ce0da.svg";